const getCartData = async () => {
  try {
    const res = await fetch('/cart.js');
    const data = await res.json();
    if (res.ok) {
      return data;
    }
  } catch (error) {
    console.log(error);
    return null;
  }
}

const getFreeGiftData = async (str) => {
  if (!str) return;
  const handle = str.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');

  try {
    const res = await fetch(`/products/${handle}.js`);
    const data = await res.json();
    if (res.ok) {
      return data;
    }
  } catch (error) {
    console.log(error);
    return null;
  }
}

const addToCart = async (e) => {
  const self = e.target;
  const parent = self.closest('.free-gift');
  if (!parent) return;

  const referId = parent.dataset.referId;
  const referType = parent.dataset.type;
  if (!referId || !referType) return;

  const variantEl = parent.querySelector('[name="variants"]');
  const variantId = variantEl.value ?? null;
  if (!variantId) return;

  self.classList.add('btn--loading');
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: +variantId,
          quantity: 1,
          properties: {
            '_free-gift-with-purchase': true,
            '_free-gift-refer-id': referId,
            '_free-gift-refer-type': referType
          }
        }]
      })
    });
    const data = await res.json();
    if (res.ok) {
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: {
          data: data
        }
      }));
    }
  } catch (error) {
    console.log(error)
  } finally {
    self.classList.remove('btn--loading');
  }
};

const removeFreeGift = async (data) => {
  console.log('Removing free gift', { data });
  const { key } = data;
  if (!key) return;

  const cartForm = document.getElementById('CartDrawerForm');

  cartForm.classList.add('loading', 'no-event');
  try {
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        updates: {
          [key]: 0
        }
      })
    });
    if (res.ok) {
      console.log('Free gift removed');
      // Event used to update cart
      document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
    }
  } catch (error) {
    console.log(error);
  } finally {
    cartForm.classList.remove('loading', 'no-event');
  }
}

const init = async (e) => {
  const cartData = await getCartData();
  if (!cartData) return;

  const { items } = cartData;
  const freeGifts = items.filter((item) => item.properties && item.properties['_free-gift-with-purchase']);

  if (Array.isArray(freeGifts) && freeGifts.length) {
    freeGifts.forEach((freeGift) => {
      const referId = freeGift.properties['_free-gift-refer-id'];
      const referType = freeGift.properties['_free-gift-refer-type'];

      if (referType && referType === 'bundle') {
        const referBundle = items.some(item => item.properties['_bundleUniqueID'] === referId);
        if (!referBundle) removeFreeGift(freeGift);
      }

      if (referType && referType === 'product') {
        const referProduct = items.find((item) => item.key === referId);
        if (!referProduct) removeFreeGift(freeGift);
      }
    });
  }
}

class FreeGiftWithPurchase extends HTMLElement {
  constructor() {
    super();
    this.#initialize();
  }

  async #initialize() {
    const type = this.dataset.type;
    const tag = this.dataset.tag;
    const referId = this.dataset.referId;
    if (!type || !referId || !tag) return;

    const cartData = await getCartData();
    if (!cartData) return;

    const { items } = cartData;
    const freeGift = items.find(item => item.properties && item.properties['_free-gift-with-purchase'] && item.properties['_free-gift-refer-id'] === referId);
    // Exit since free gift is already in cart
    if (freeGift) {
      return;
    }

    const handle = tag.replace('_fgwp_', '');
    const data = await getFreeGiftData(handle);
    this.#render({ data, referId, type });
  }

  #render({ data, referId, type }) {
    if (!data || !type || !referId) return;

    const details = document.createElement('details');
    const summary = document.createElement('summary');
    const content = document.createElement('div');

    const variants = () => {
      const { variants } = data;
      let markup = '';

      if (variants.length === 1) {
        const [ onlyVariant ] = variants;
        markup = `
          <input type="hidden" name="variants" value="${onlyVariant.id}">
        `;
      } else {
        markup = `
          <select name="variants">${ variants.map(variant => `<option value="${variant.id}"${variant.available ? "" : " disabled"}>${variant.title}</option>`).join('') }</select>
        `;
      }
      return markup;
    }

    // Summary label
    summary.innerText = 'Add your free gift';
    summary.classList.add('cart__item-name');

    // Contents
    content.classList.add('contents');
    content.innerHTML = `
      <div class="free-gift" data-type="${type}" data-refer-id="${referId}">
        <a href="${data.url}" class="media media-fit-cover">
          <img src="${data.featured_image}" alt="${data.title}" loading="lazy" style="aspect-ratio: 1;" />
        </a>
        <div>
          <a href="${data.url}" class="cart__item-name">${data.title}</a>
          ${variants()}
          <button type="button" name="add-free-gift" class="btn">Add</button>
        </div>
      </div>
    `;

    details.append(summary, content);
    details.open = true; // Sets detail element to be open initially
    this.append(details);

    const button = this.querySelector('button[name="add-free-gift"]');
    if (button) {
      button.addEventListener('click', addToCart);
    }
  }
}
customElements.define('free-gift-with-purchase', FreeGiftWithPurchase);


['DOMContentLoaded', 'cart:ready'].forEach((event) => {
  document.addEventListener(event, init);
});


const confirmation = document.querySelector("#backdrop");
const btnCheckout = document.querySelector("#CartDrawerForm .btn.cart__checkout");

const btnCheckoutCart = document.querySelector("#CartPageForm .btn.cart__checkout");
const btnCancel = document.querySelector(".btn.btn__cancel");
const btnContinue = document.querySelector(".btn.btn__continue");

btnCheckout?.addEventListener("click", btnCheckoutClick, false);

if ( btnCheckoutCart != null ) {
  btnCheckoutCart.addEventListener("click", btnCheckoutClick, false);
}

btnCancel?.addEventListener("click", function () {
  confirmation.classList.remove('active');
});

btnContinue?.addEventListener("click", function (){
  fetch('/cart/update.js', {
    method: 'POST',
    body: JSON.stringify({
      note: "I don't want free gift"
    }),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
  .then(response => response.json())
  .then(function(cart) {
    confirmation.classList.remove('active');
    btnCheckout.classList.add('btn--loading')
    window.location.href = "/checkout";
  });
});

function btnCheckoutClick(event) {
  let freeGiftAdded = document.querySelector("free-gift-with-purchase > *");
  event.preventDefault();

  if ( freeGiftAdded != null) {
    confirmation.classList.add('active');
  } else {
    fetch('/cart/update.js', {
      method: 'POST',
      body: JSON.stringify({
        note: ""
      }),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.json())
    .then(function() {
      confirmation.classList.remove('active');
      btnCheckout.classList.add('btn--loading')
      window.location.href = "/checkout";
    });
  }
}